<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Task Quick Commands') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|When enabled, task reports will include quick command shortcuts (e.g., /i123_456) next to each task ID. These commands allow you to quickly access task details and perform actions directly from Telegram.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|How It Works') }}</h4>
            <p>
              {{
                s__(
                  "Profile|Each task has a global ID displayed in monospace format. When quick commands are enabled, you'll see a clickable command like /i123_456 next to the task ID in reports."
                )
              }}
            </p>

            <h4>{{ s__('Profile|Example') }}</h4>
            <p>
              {{
                s__(
                  'Profile|In a report, you might see: "Task 123-456: Complete feature". Clicking on /i123_456 will open the task details in Telegram, where you can view information and perform quick actions.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.commands-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 0 16px 0;
}

.commands-table tr {
  border-bottom: 1px solid #e0e0e0;
}

.commands-table tr:last-child {
  border-bottom: none;
}

.commands-table td {
  padding: 12px 8px;
  vertical-align: top;
}

.command-cell {
  min-width: 150px;
  color: #333;
}

.command-cell code {
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #2aabee;
}

.description-cell {
  color: #666;
  line-height: 1.5;
}
</style>
